import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// assets
import wavesImage from "../../assets/png/wavesEvent.png";
import logo from "../../assets/png/JioCloud-Logo.png";

import styles from "./UserEventRegistration.module.css";
import classes from "../UserRegistration/UserRegistration.module.css";

// Mui & Jds
import { Alert, Box, Snackbar, Stack } from "@mui/material";
import { Button, InputField, Notifications, Skeleton, Text } from "@jds/core";

// Local
import useApiHttp from "../../hooks/use-http";
import PageLoader from "../../components/UI/Loader/PageLoader";
import useInput from "../../hooks/use-input";
import {
  validateEmail,
  validateNameWithOnlyLetters,
  validateTextInput,
} from "../../util/validation";
import EventRegistrationSecondaryBtn from "../../components/UI/EventRegistrationSecondaryBtn/EventRegistrationSecondaryBtn";
import decryptUrl from "../../util/img-decryption";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CustomFields from "../../components/CustomFields/CustomFields";
import { useSelector } from "react-redux";

const UserEventRegistration = () => {
  const params = new URLSearchParams(useLocation().search);
  const navigate = useNavigate();
  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const eventId = params.get("eventId");
  const eventName = localStorage.eventName;
  const bannerThumbnailURl = localStorage.bannerThumbnailURl;
  const [toastOpen, setToastOpen] = useState(false);
  const [toastInfo, setToastInfo] = useState({
    msg: "Notification",
    type: "success",
  });
  const [customFields, setCustomFields] = useState([]);
  const [cutomFieldsValue, setCustomFieldsValue] = useState(null);
  const [customFieldsVali, setCustomFieldsVali] = useState({});
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loginErrors, setLoginErrors] = useState({});

  const { sendRequest: getEventDetails, isLoading: eventDetailsLoading } =
    useApiHttp();
  const { sendRequest: getCustomField, isLoading: isCustomFieldLoading } =
    useApiHttp();
  const { sendRequest: guestRegister, isLoading: isGuestRegistering } =
    useApiHttp();

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput((data) => {
    if (typeof data !== "string") return false;
    if (data.length > 20) return false;
    const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
    return pattern.test(data);
  });
  const {
    value: lastName,
    isValid: isValidlastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput((data) => {
    if (typeof data !== "string") return false;
    if (data.length > 20) return false;
    const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
    return pattern.test(data);
  });
  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    reset: resetEmailAddress,
  } = useInput((e) => {
    // console.log('email', e)
    // if (!e) {
    //   return false
    // }
    if (e) {
      return validateEmail(e);
    } else {
      return true;
    }
  });
  const isValidForm =
    !isValidFirstName ||
    !isValidlastName ||
    // !isValidEmailAddress ||
    !Object?.values(customFieldsVali)?.every((value) => value === true) ||
    (emailAddress && !isValidEmailAddress);

  const handleGuestRegister = (e) => {
    const formData = new FormData();
    formData.append("deviceType", "WEB");
    formData.append(
      "email",
      emailAddress ? emailAddress.trim().toLowerCase() : "",
    );

    formData.append("firstName", firstName.trim());
    formData.append("lastName", lastName.trim());
    formData.append("eventId", eventId);
    formData.append("customField", JSON.stringify(cutomFieldsValue));

    guestRegister(
      {
        url: "event-attendee/guest/register",
        method: "POST",
        body: formData,
        formData: true,
      },
      null,
      (data) => {
        navigate(`/user-registered/user-status?eventId=${eventId}`, {
          replace: true,
        });
      },
      (_, err) => {
        setLoginErrors(err?.errors);

        setToastInfo({
          msg: err?.message,
          type: "error",
        });
        setToastOpen(true);
      },
    );
  };
  const getCustomFieldHandler = () => {
    getCustomField(
      {
        url: `event/${eventId}/custom_field`,
        method: "GET",
      },
      null,
      (data) => {
        setCustomFields(data?.data?.customField);
        if (data?.data?.firstName) {
          firstNameChangeHandler({
            target: { value: data?.data?.firstName || "" },
          });
          firstNameBlurHandler();
        }
        if (data?.data?.lastName) {
          lastNameChangeHandler({
            target: { value: data?.data?.lastName || "" },
          });
          lastNameBlurHandler();
        }
        if (data?.data?.email) {
          emailAddressChangeHandler({
            target: { value: data?.data?.email || "" },
          });
          emailAddressBlurHandler();
        }
        if (Array.isArray(data?.data?.customField)) {
          const cusField = data?.data?.customField?.map((item) => {
            return {
              id: item?.id,
              value: item?.type === "checkbox" ? [] : "",
            };
          });
          setCustomFieldsValue(cusField);
          const validObj = data?.data?.customField?.reduce((acc, item) => {
            acc[item.id] = !item.required;
            return acc;
          }, {});
          setCustomFieldsVali(validObj);
        }
        if (data?.data?.customField == null) {
          setCustomFieldsVali({ id: true });
        }
      },
      (_err) => {},
    );
  };

  useEffect(() => {
    getCustomFieldHandler();
    setToastInfo({
      msg: "OTP verified successfully",
      type: "success",
    });
    setToastOpen(true);
  }, []);

  return (
    <>
      <header
        style={{
          height: "50px",
          padding: "5px 24px",
          backgroundColor: "var(--color-primary-50)",
        }}
      >
        <div className={classes["header__container"]}>
          <Stack direction="row" gap={1} alignItems="center">
            <img src={logo} alt="jio photos logo" style={{ width: "40px" }} />
          </Stack>
        </div>
      </header>
      <Box
        sx={{
          // backgroundColor: "#54086E",
          // minHeight: "calc(100vh)",
          pt: "50px",
          // maxWidth: "768px",
          margin: "0 auto",
          "@media screen and (min-width: 768px)": {
            p: "92px 0 32px",
            maxWidth: "360px",
          },
        }}
      >
        <div className={classes["user-registration__card"]}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              aspectRatio: "16 / 9",
              overflow: "hidden",
              "& .j-JDSSkeleton-container ": {
                borderRadius: 0,
              },
            }}
          >
            {bannerThumbnailURl && (
              <img
                src={bannerThumbnailURl}
                alt="blurred-banner"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  filter: "blur(20px)",
                  transform: "scale(1.05)",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  transition: "opacity 0.3s ease-in-out",
                  opacity: imageLoaded ? 0 : 1,
                  zIndex: 2,
                }}
              />
            )}

            {bannerThumbnailURl && (
              <LazyLoadImage
                src={decryptUrl(bannerThumbnailURl)}
                alt="event banner"
                afterLoad={() => setImageLoaded(true)}
                width="100%"
                height="100%"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  opacity: imageLoaded ? 1 : 0,
                  transition: "opacity 0.6s ease-in-out",
                  zIndex: 3,
                }}
              />
            )}
          </Box>

          <Stack
            direction="column"
            gap={4}
            alignItems="center"
            mt={4}
            p={"12px 24px 32px"}
            sx={{ "& .j-JDSText-text ": { textAlign: "center" } }}
          >
            <Text text={eventName} appearance="heading-xs" />
            <Box
              sx={{
                width: "100%",
                // "& .text-atom": { color: "#fff", opacity: 0.6 },
                // "& input": { color: "#fff", caretColor: '#fff' },
                // "& .j-JDSInputField-feedback-container": {
                //   backgroundColor: "#fff",
                // },
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                <InputField
                  label="First Name *"
                  value={firstName}
                  name="firstName"
                  onChange={(e) => {
                    // firstNameChangeHandler({
                    //   target: { value: e.target.value.trim() },
                    // });

                    firstNameChangeHandler(e, e.target.value);
                  }}
                  onBlur={firstNameBlurHandler}
                  state={
                    firstNameError || loginErrors?.firstName ? "error" : ""
                  }
                  stateText={
                    loginErrors?.firstName || firstName?.length > 20
                      ? "The First name length can't exceed 20 characters"
                      : firstName?.length == 0
                        ? "The First name can't be blank"
                        : "The First name can't contain spaces, special characters and numbers"
                  }
                />
                <InputField
                  label="Last Name *"
                  value={lastName}
                  name="lastName"
                  // state={lastNameError ? "error" : ""}
                  state={lastNameError || loginErrors?.lastName ? "error" : ""}
                  stateText={
                    loginErrors?.lastName || lastName?.length > 20
                      ? "The Last name length can't exceed 20 characters"
                      : lastName?.length == 0
                        ? "The Last name can't be blank"
                        : "The Last name can't contain spaces, special characters and numbers"
                  }
                  onChange={(e) => {
                    lastNameChangeHandler(e, e.target.value);
                  }}
                  onBlur={lastNameBlurHandler}
                />
                <InputField
                  label="Email"
                  value={emailAddress}
                  name="emailAddress"
                  state={emailAddressError ? "error" : ""}
                  stateText="Please enter a valid email id!"
                  type={"email"}
                  onChange={emailAddressChangeHandler}
                  onBlur={emailAddressBlurHandler}
                />
                <Box
                  sx={{
                    ".j-JDSRadioButton-label-jds-text .text-atom": {
                      maxWidth: "200px",
                      wordWrap: "break-word",
                    },
                    ".j-JDSCheckbox-label-jds-text .text-atom": {
                      maxWidth: "200px",
                      wordWrap: "break-word",
                      textAlign: "left",
                    },
                    ".j-JDSRadioButton-horizontal-container, .j-JDSCheckbox-horizontal-container":
                      {
                        alignItems: "flex-start",
                      },

                    ".j-JDSCheckbox-control-container, .j-JDSRadioButton-outer-container":
                      { marginTop: "3px" },
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px",
                  }}
                >
                  {customFields?.map((customField, index) => (
                    <CustomFields
                      type={customField?.type}
                      customFieldProp={customField}
                      setCustomFieldsValue={setCustomFieldsValue}
                      setCustomFieldsVali={setCustomFieldsVali}
                    />
                  ))}
                </Box>
                <Box sx={{ pt: 3 }}>
                  <Button
                    label="Register"
                    fullWidth
                    onClick={() => {
                      handleGuestRegister();
                    }}
                    disabled={isValidForm || isGuestRegistering}
                  >
                    {/* Continue */}
                  </Button>
                </Box>
              </div>
            </Box>
          </Stack>
        </div>
      </Box>
      <Box>
        {isCustomFieldLoading && <PageLoader open={isCustomFieldLoading} />}
      </Box>

      {/* toast */}
      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={() => {
          setToastOpen(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => {
            setToastOpen(false);
          }}
          severity={toastInfo.type}
          sx={{ width: "100%" }}
        >
          {toastInfo.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserEventRegistration;
